module.exports = __webpack_public_path__ + "media/img/horizontal-logo-small-48c8fbe35d465075af712928ac399ea1.png";